export default __webpack_public_path__ + "static/marticka-3811c577a7d286f5065012071304982d.jpg";